import * as React from 'react'
import type { GroupedViolationModel } from '@/app/models/groupedViolationModel'
import { LoaderIcon } from '@/app/features/icons/Loader'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { formatPln } from '../formatPln'

type Summed = Omit<GroupedViolationModel, 'driver'>

type Props = {
  violations: ReadonlyArray<Summed>
  isLoading: boolean
}

// WPF ViolationsView: pasek „Suma kar” pod listą w trybie grupowym.
const ViolationsGroupedFooterBar: React.FC<Props> = ({
  violations,
  isLoading,
}) => {
  const { t } = useLocalize()

  const sum = (pick: (v: Summed) => number | undefined) =>
    violations.reduce((s, v) => s + (pick(v) || 0), 0)

  const driverCharge = sum((v) => v.driverCharge)
  const companyCharge = sum((v) => v.companyCharge)
  const counts = [
    ['NN', sum((v) => v.amount_NN)],
    ['BPN', sum((v) => v.amount_BPN)],
    ['PN', sum((v) => v.amount_PN)],
    ['ZN', sum((v) => v.amount_ZN)],
  ] as const

  const title = t(
    violations.length === 1
      ? 'driverViolations.checked-driver-charge-sum'
      : 'driverViolations.checked-drivers-charge-sum',
  ).replace('{0}', String(violations.length))

  return (
    <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-5 tw-border-t-2 tw-border-base-300 tw-bg-base-100 tw-px-4 tw-py-2 tw-text-[13px] tw-font-medium tw-text-[#343434]">
      {counts.map(([label, value]) => (
        <span key={label}>
          <span className="tw-font-normal tw-text-[#666]">{label}: </span>
          <strong>{value}</strong>
        </span>
      ))}
      <span className="tw-ml-auto tw-flex tw-items-center tw-gap-2 tw-text-[#555]">
        {isLoading && <LoaderIcon className="tw-w-4 tw-animate-spin" />}
        {title}
      </span>
      <span>
        <span className="tw-font-normal tw-text-[#666]">
          {t('violation.driverCharge')}:{' '}
        </span>
        <strong>{formatPln(driverCharge)}</strong>
      </span>
      <span>
        <span className="tw-font-normal tw-text-[#666]">
          {t('violation.companyCharge')}:{' '}
        </span>
        <strong>{formatPln(companyCharge)}</strong>
      </span>
      <span>
        <span className="tw-font-normal tw-text-[#666]">
          {t('driverModule.total-violations-amount')}:{' '}
        </span>
        <strong>{formatPln(driverCharge + companyCharge)}</strong>
      </span>
    </div>
  )
}

export default ViolationsGroupedFooterBar
